import React from 'react';
import MapPage from './MapPage';
import TcfComplexityPanel from '../../components/project/TcfComplexityPanel';

/**
 * "Mapas" module — a single presentation of the airport's spatial data. The
 * airport map and the analysis heatmaps were merged into one Mapbox view whose
 * layer panel switches between infrastructure, heatmap and AviPLAN layers, so
 * there is one map instead of two tabs showing the same airport. The
 * taxiway-complexity cards (TCF + Block-2 factors) sit below, describing the
 * same spatial complexity. The operational KPI data lives in the KPIs module.
 */
const MapasPage: React.FC = () => (
  <div className="space-y-6 animate-fade-in">
    <MapPage />
    <TcfComplexityPanel />
  </div>
);

export default MapasPage;
